import {default as defaultTransitions} from '@material-ui/core/styles/transitions';

import type {Transitions} from '@material-ui/core/styles/transitions';

export const transitionsNormal: Partial<Transitions> = {
    duration: {
        shortest: defaultTransitions.duration.shortest, // default
        shorter: defaultTransitions.duration.shorter, // default
        short: defaultTransitions.duration.short, // default
        standard: defaultTransitions.duration.standard, // default
        complex: defaultTransitions.duration.complex, // default
        enteringScreen: 150,
        leavingScreen: 120,
    },
};

export const transitionsNone: Partial<Transitions> = {
    duration: {
        shortest: 0,
        shorter: 0,
        short: 0,
        standard: 0,
        complex: 0,
        enteringScreen: 0,
        leavingScreen: 0,
    },
};
